import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const InfoFilled = createSvgIcon(
  <path d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm1.125-16.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Zm0 2.625V18h-2.25V9.75h2.25Z" />,
  'InfoFilled'
);

export { InfoFilled };
